/**
 * Elenco dei negozi aggiornato dal realtime di commerce_stores (unica tabella e-commerce in realtime,
 * 00 contraddizione 2.6). Modulo puro: riduttore delle modifiche e ordinamento.
 */

export interface RealtimeChange<T> {
  eventType: 'INSERT' | 'UPDATE' | 'DELETE';
  new: Partial<T> | Record<string, never>;
  old: Partial<T> | Record<string, never>;
}

interface Keyed {
  id: string;
}

export function applyStoreChange<T extends Keyed>(list: T[], change: RealtimeChange<T>): T[] {
  if (change.eventType === 'DELETE') {
    const id = (change.old as Partial<T>).id;
    if (!id) return list;
    return list.filter((s) => s.id !== id);
  }
  const next = change.new as Partial<T>;
  if (!next.id) return list;
  const i = list.findIndex((s) => s.id === next.id);
  if (i === -1) return [...list, next as T];
  const out = list.slice();
  out[i] = { ...list[i], ...next } as T;
  return out;
}

export function sortStores<T extends Keyed & { status: string; created_at: string }>(list: readonly T[]): T[] {
  return [...list].sort((a, b) => {
    const da = a.status === 'disconnected' ? 1 : 0;
    const db = b.status === 'disconnected' ? 1 : 0;
    return da - db || a.created_at.localeCompare(b.created_at);
  });
}

/** sync_state.updated_at e' cambiato: elenco lavori e registro vanno riletti (08 sez. 3.2). */
export function syncStateChanged(prev: unknown, next: unknown): boolean {
  const at = (v: unknown) => (typeof v === 'object' && v !== null ? (v as Record<string, unknown>).updated_at ?? null : null);
  return at(prev) !== at(next) || prev === null;
}
